import { useEffect, useState } from 'react';

export const useIsElectron = (): boolean => {
  const [isElectron, setIsElectron] = useState(false);

  useEffect(() => {
    if (window.app.isElectron) {
      setIsElectron(true);
    }
  }, []);

  return isElectron;
};
